import { render, staticRenderFns } from "./waterPurifierDetail.vue?vue&type=template&id=6c7adcf8&scoped=true"
import script from "./waterPurifierDetail.vue?vue&type=script&lang=js"
export * from "./waterPurifierDetail.vue?vue&type=script&lang=js"
import style0 from "./waterPurifierDetail.vue?vue&type=style&index=0&id=6c7adcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7adcf8",
  null
  
)

export default component.exports